import { selectUser } from './selectUser';
import { IApplicationState } from '../../types/redux';

export const selectUserPhone = (state: IApplicationState) => {
  const user = selectUser(state);
  const phone = user.isAuthenticated && user.phones[0]?.phone;

  return phone || null;
};
